import React, { Component, PureComponent } from 'react'
import CKEditor from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import Api from '~/api'
import axios from 'axios'

class UploadAdapter {
  constructor(loader) {
    this.loader = loader
  }

  upload() {
    let ckLoader = this.loader

    return ckLoader.file.then(file => {
      let { name, size, type, access = 'private' } = file

      return Api.post('/file', { file: { name, size, type, access } })
        .then(({ data: { postData, file: fileEntry } = {} }) => {
          let formData = new FormData()
          for (let key in postData.fields) {
            formData.append(key, postData.fields[key])
          }

          formData.append('file', file, name)

          return (
            axios({
              method: 'POST',
              url: postData.url,
              data: formData,
              onUploadProgress: e => {
                ckLoader.uploadTotal = e.total
                ckLoader.uploaded = e.uploaded
              },
            })
              /* Return files url ckeditor */
              .then(() => ({
                default: fileEntry.url,
              }))
          )
        })
        .catch(err => {
          console.log(err)
        })
    })
  }

  abort() {
    server.abortUpload()
  }
}

export default function WysiwygField({ value, name, id, onChange, disabled, emailTemplate = false }) {
  let classes = ['form-field-wysiwyg']
  if (emailTemplate) classes.push('form-field-wysiwyg--emailtemplate')

  return (
    <div className={classes.join(' ')}>
      <CKEditor
        editor={ClassicEditor}
        key={value.toString()}
        onInit={editor => {
          editor.plugins.get('FileRepository').createUploadAdapter = loader => new UploadAdapter(loader)
        }}
        data={value}
        onBlur={(event, editor) => {
          onChange({ name, value: editor.getData() })
        }}
      />
    </div>
  )
}
